// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "baa47e83" + "." + "7e84b801e9669f4f" + ".js";
};